import React from "react";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";

const SomethingWentWrong = () => {
  const somethingWentWrong =
    "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/something_went_wrong.png";
  return (
    <div className="no-page-wrapper">
      <img
        src={somethingWentWrong}
        alt="Something went wrong"
        className="error-img"
      />
      <p className="go-to-text">
        Go back to{" "}
        <Link to={PATHS.HOME} className="previous-page">
          Previous Page
        </Link>
      </p>
    </div>
  );
};

export default SomethingWentWrong;
